"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiLinearProgress: {
    colorPrimary: {
      backgroundColor: _theme.palette.primary.light
    },
    root: {
      borderRadius: "2px",
      height: _theme.spacing[1]
    }
  }
};
exports.default = _default;